// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/000fb780/" + chunkId + "." + __webpack_require__.h() + ".v000fb780.js";
};